import React from 'react'
import { ArrowLeft, Loader2, RefreshCw } from 'lucide-react'
import { t } from '@okclawpro/i18n'
import type { RemoteDeviceView, RemoteConnectTicket } from './remote-devices'

export interface ConnectingDevicePageProps {
  device: RemoteDeviceView
  ticket: RemoteConnectTicket | null
  error?: string
  onRetry: () => void
  onBack: () => void
}

export default function ConnectingDevicePage({
  device,
  ticket,
  error,
  onRetry,
  onBack,
}: ConnectingDevicePageProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/30 px-4 py-6 font-sans text-foreground">
      <section className="w-full max-w-[460px] rounded-lg border border-border/70 bg-background px-5 py-5 shadow-[0_18px_60px_rgba(15,23,42,0.10)]">
        <button
          type="button"
          className="mb-5 inline-flex h-9 items-center gap-2 rounded-md border border-border px-3 text-[13px] text-muted-foreground transition-colors hover:text-foreground"
          onClick={onBack}
        >
          <ArrowLeft className="h-4 w-4" />
          {t('webui.remote.backToList')}
        </button>
        <div className="flex flex-col items-center text-center">
          <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-full ${error ? 'bg-destructive/10 text-destructive' : 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400'}`}>
            {error ? <RefreshCw className="h-5 w-5" /> : <Loader2 className="h-5 w-5 animate-spin" />}
          </div>
          <h1 className="text-[20px] font-semibold leading-7">
            {error ? t('webui.remote.connecting.failedTitle') : t('webui.remote.connecting.title')}
          </h1>
          <p className="mt-2 text-[13px] leading-5 text-muted-foreground">
            {error
              ? error
              : t('webui.remote.connecting.description', { name: device.name })}
          </p>
          {ticket ? (
            <p className="mt-3 rounded-md border border-border bg-muted/40 px-3 py-2 text-[12px] text-muted-foreground">
              {t('webui.remote.connecting.ticketReady')}
            </p>
          ) : null}
          {error ? (
            <button
              type="button"
              className="mt-5 inline-flex h-10 items-center justify-center gap-2 rounded-md bg-zinc-950 px-4 text-[13px] font-semibold text-white hover:bg-zinc-800 dark:bg-zinc-50 dark:text-zinc-950 dark:hover:bg-zinc-200"
              onClick={onRetry}
            >
              <RefreshCw className="h-4 w-4" />
              {t('webui.remote.retry')}
            </button>
          ) : null}
        </div>
      </section>
    </main>
  )
}
